import { render, staticRenderFns } from "./CostTagsPieChart.vue?vue&type=template&id=f5680074"
import script from "./CostTagsPieChart.vue?vue&type=script&lang=js"
export * from "./CostTagsPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports